import type { HelpFile } from '../../types/help'
import { AccountDetailTestIds } from '../../../testids/AccountDetailTestIds'

export const accountDetailHelp: HelpFile = {
  docPage: '/docs/identity/accounts',
  texts: {
    [AccountDetailTestIds.accountDetailPage]:
      'Vollständiger Datensatz eines Kontos — Eigentümer, Zielsystem, aktueller Lebenszyklusstatus und Audit-Zeitstempel.',
    [AccountDetailTestIds.cardAccountDetails]:
      'Kernfelder des Kontos aus dem Zielsystem und der verknüpften Identität.',
    [AccountDetailTestIds.linkAccountIdentity]:
      'Die Identität, für die dieses Konto bereitgestellt wurde. Über den Link gelangen Sie zum Identitätsprofil.',
    [AccountDetailTestIds.linkAccountSystem]:
      'Das Zielsystem, dem dieses Konto gehört. Über den Link gelangen Sie zur Systemübersicht.',
    [AccountDetailTestIds.accountExternalIdentifier]:
      'Die Kennung, mit der das Zielsystem dieses Konto identifiziert — etwa der LDAP-DN, der Datenbankbenutzername oder die SCIM-User-ID. Wird beim Abgleich mit dem führenden System verwendet.',
    [AccountDetailTestIds.accountStatusBadge]:
      'Aktueller Lebenszyklusstatus des Kontos im Zielsystem: aktiviert, deaktiviert oder gesperrt.',
    [AccountDetailTestIds.sectionAccountAttributes]:
      'Dynamische Attribute dieses Kontos — erweitern das Schema ohne Codeänderungen.',
  },
}
